import * as React from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import { Button, Text, makeStyles, mergeClasses, tokens } from "@fluentui/react-components";

import { backgroundColorSeaGreen, useIconButtonStyles } from "../styles/styles";
import { ThemeContext } from "../store/theme-context-api";
import { PATHS } from "./routes/paths";

const useStyles = makeStyles({
  navLink: {
    position: "relative",
    textDecoration: "none",
  },

  navLinkHover: {
    ":hover": {
      "&::after": {
        content: '""',
        position: "absolute",
        left: 0,
        bottom: 0,
        height: "2px",
        width: "100%",
        borderRadius: "8px",
        transition: "width 0.3s ease, left 0.3s ease",
      },
    },
  },

  navLinkDark: {
    ":hover": {
      "&::after": {
        backgroundColor: tokens.colorNeutralBackground1Hover,
      },
    },
  },

  navLinkLight: {
    ":hover": {
      "&::after": {
        backgroundColor: tokens.colorNeutralStroke1Hover,
      },
    },
  },

  navBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "unset",
  },

  navLabel: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },

  activeNavIndicator: {
    width: "100%",
    height: "2px",
    borderRadius: "8px",
  },

  activeNavIndicatorDark: { backgroundColor: backgroundColorSeaGreen },

  activeNavIndicatorLight: { backgroundColor: tokens.colorNeutralBackground2Hover },
});

export default function NavButton({ icon, label, link }) {
  const { isDarkTheme } = React.useContext(ThemeContext);
  const styles = useStyles();
  const iconStyles = useIconButtonStyles();

  const match = useRouteMatch({ path: link, exact: link === PATHS.HOME_PAGE });
  const isActive = Boolean(match);
  const navLinkClass = !isActive
    ? isDarkTheme
      ? mergeClasses(styles.navLink, styles.navLinkDark, styles.navLinkHover)
      : mergeClasses(styles.navLink, styles.navLinkLight, styles.navLinkHover)
    : isDarkTheme
      ? mergeClasses(styles.navLink, styles.navLinkDark)
      : mergeClasses(styles.navLink, styles.navLinkLight);

  const navButtonClass = mergeClasses(styles.navBtn, isDarkTheme ? iconStyles.dark : iconStyles.light);

  const activeNavIndicatorClass = mergeClasses(
    styles.activeNavIndicator,
    isDarkTheme ? styles.activeNavIndicatorDark : styles.activeNavIndicatorLight,
  );

  return (
    <NavLink to={link} className={navLinkClass}>
      <Button appearance="transparent" size="small" className={navButtonClass}>
        <span className="text-[20px]">{icon}</span>
        <Text className={styles.navLabel}>{label}</Text>
      </Button>

      {isActive && <div className={activeNavIndicatorClass}></div>}
    </NavLink>
  );
}
